import { Translation } from "./Translation";

export class Tag {
  private constructor(
    readonly id: string,
    readonly ticker: string,
    readonly translations: Translation[],
    readonly appliesTo: TagAppliesTo[]
  ) {}

  static of(
    id: string,
    ticker: string,
    translations: Translation[],
    appliesTo: TagAppliesTo[]
  ): Tag {
    return new Tag(id, ticker, translations, appliesTo);
  }

  getTitle(locale: string): string {
    const shortLocale = locale.includes("-") ? locale.split("-")[0] : locale;
    const translation = this.translations.find(t => t.locale === shortLocale);
    if (translation) {
      return translation.translation;
    }

    return this.translations.length > 0 ? this.translations[0].translation : this.ticker;
  }
}

export class TagAppliesTo {
  private constructor(readonly type: TagAppliesToType, readonly tickers: TickerWithPosition[]) {}

  static of(type: TagAppliesToType, tickers: TickerWithPosition[]) {
    return new TagAppliesTo(type, tickers);
  }
}

export class TickerWithPosition {
  private constructor(readonly ticker: string, readonly position: number) {}

  static of(ticker: string, position: number) {
    return new TickerWithPosition(ticker, position);
  }
}

export const TAG_APPLIES_TO_TYPES = ["property", "accommodation", "package", "extra"] as const;
export type TagAppliesToType = typeof TAG_APPLIES_TO_TYPES[number];
